import _ from 'lodash';
import constants from '../../../../config/constants';
import { getPriceToNumber } from '../../../../utils/PriceHelpers';
import { formatSlotDate, getLocaleTime, pad } from '../utils';

const { MONTHS, AVAILABILITY_PICKUPINSTORE } = constants;

function buildPickupItem({ title, cost, storeId, storeName }, tenant) {
  const raw = typeof cost === 'string' ? cost.replace(/[^\d.,]/g, '') : cost;

  const numCost = typeof raw === 'string' ? getPriceToNumber(raw, tenant) : raw;

  return {
    title,
    price: !numCost || Number.isNaN(numCost) ? 'Gratis' : cost,
    storeId,
    storeName,
    show: true,
    isDateRange: false,
  };
}

const getSelectedPickupInStoreDetails = (selectedStore, regionCode) => {
  const now = new Date(getLocaleTime(regionCode));
  const today = now.getDate();
  const { storeId, storeName, earliestAvailableSlot, deliverySlots = [] } = selectedStore;
  const earliestDate = Number(_.get(earliestAvailableSlot, 'slotDate.date', 0));
  const earliestMonth = _.get(earliestAvailableSlot, 'slotDate.month', '');

  const result = [];

  if (earliestDate === today) {
    result.push(
      buildPickupItem({
        title: 'Retira hoy',
        cost: earliestAvailableSlot.cost,
        storeId,
        storeName,
      })
    );
    const nextSlot = deliverySlots.find((slot) => Number(_.get(slot, 'slotDate.date', 0)) !== today);
    if (nextSlot) {
      const d = Number(_.get(nextSlot, 'slotDate.date', 0));
      const m = _.get(nextSlot, 'slotDate.month', '');
      result.push(
        buildPickupItem({
          title: `Retira a partir del ${formatSlotDate(d, m)}`,
          cost: nextSlot.cost,
          storeId,
          storeName,
        })
      );
    }
  } else {
    result.push(
      buildPickupItem({
        title: `Retira a partir del ${formatSlotDate(earliestDate, earliestMonth)}`,
        cost: earliestAvailableSlot.cost,
        storeId,
        storeName,
      })
    );
  }

  return result;
};

const processPickupInStoreSlots = (listOfStores, regionCode) => {
  const currentLocaleTime = getLocaleTime(regionCode);
  const currentDate = new Date(currentLocaleTime).getDate();

  const result = listOfStores.map((store) => {
    const earliestAvailableSlotDate = Number(_.get(store, 'earliestAvailableSlot.slotDate.date', 0));
    const earliestAvailableSlotMonth = _.get(store, 'earliestAvailableSlot.slotDate.month', '').toLowerCase();
    const earliestAvailableSlotInfo =
      earliestAvailableSlotDate === currentDate
        ? 'A partir de hoy'
        : `A partir del ${pad(earliestAvailableSlotDate)}/${MONTHS[earliestAvailableSlotMonth]}`;
    return {
      ...store,
      earliestAvailableSlotInfo,
    };
  });
  return result;
};

const getPickupInStoreSlots = async ({ regionCode, storePickUp }) => {
  const stores = _.get(storePickUp, 'data.storePickUp.listOfStores', []);
  if (!stores || stores.length === 0) {
    return [];
  }
  const result = processPickupInStoreSlots(stores, regionCode);
  if (result && Array.isArray(result) && result.length > 0) {
    return result;
  }
  return [];
};

const getPickupInStoreData = async ({
  comuna,
  regionCode,
  setComunaName,
  setPickupInStoreData,
  setSelectedStoreId,
  selectedDeliveryOption,
  setSelectedDeliveryOption,
  setParentStateName,
  setDeliveryError,
  storePickUp,
  setIsMapView,
}) => {
  // if (initial) {
  //   // if (isDefaultComuna) {
  //   //   return;
  //   // }
  //   const comunaName = _.get(zoneConfig, 'name', '');
  //   const parentStateName = _.get(zoneConfig, 'parentStateName', '');
  //   setParentStateName(parentStateName);
  //   const ccData = await getPickupInStoreSlots({
  //     regionCode,
  //     storePickUp,
  //   });
  //   if (ccData && Array.isArray(ccData) && ccData.length > 0) {
  //     setDeliveryError(AVAILABILITY_PICKUPINSTORE, false);
  //     setPickupInStoreData(ccData);
  //     if (selectedDeliveryOption && !_.isEmpty(selectedDeliveryOption)) {
  //       const savedStoreId = _.get(selectedDeliveryOption, 'storeId', '');
  //       if (!savedStoreId) {
  //         setSelectedStoreId(_.get(ccData, '[0].storeId', null));
  //         setComunaName(comunaName);
  //         return;
  //       }
  //       const processRes = processStoreId({
  //         storeId: savedStoreId,
  //         storesData: ccData,
  //         setSelectedStoreId,
  //         setSelectedStoreDetails,
  //         setSelectedStoreName,
  //         regionCode,
  //         zoneConfig,
  //         isFreeShippingApplicable,
  //         setSelectedDeliveryOption,
  //         parentStateName,
  //         type: 'PickupInStore',
  //         isDefaultComuna,
  //       });
  //       if (!processRes) {
  //         setComunaName(comunaName);
  //         setSelectedStoreId(_.get(ccData, '[0].storeId', null));
  //         setSaveError(true);
  //         return;
  //       }
  //     } else {
  //       setSelectedStoreId(_.get(ccData, '[0].storeId', null));
  //     }
  //     setComunaName(comunaName);
  //     setBusy(false);
  //   } else {
  //     setComunaName(comunaName);
  //     setDeliveryError(AVAILABILITY_PICKUPINSTORE, true, 'NO_PICKUP_SLOTS');
  //     setSaveError(true);
  //     setIsMapView(false);
  //     setBusy(false);
  //   }
  //   return;
  // }
  if (comuna && !_.isEmpty(comuna)) {
    const comunaName = _.get(comuna, 'name', '');
    const parentStateName = _.get(comuna, 'parentStateName', '');
    setParentStateName(parentStateName);
    const ccData = await getPickupInStoreSlots({
      regionCode,
      storePickUp,
    });
    if (ccData && Array.isArray(ccData) && ccData.length > 0) {
      setDeliveryError(AVAILABILITY_PICKUPINSTORE, false);
      setPickupInStoreData(ccData);
      setSelectedStoreId(_.get(ccData, '[0].storeId', null));
      setComunaName(_.get(comuna, 'name', ''));
    } else {
      setComunaName(_.get(comuna, 'name', ''));
      setPickupInStoreData([]);
      setDeliveryError(AVAILABILITY_PICKUPINSTORE, true, 'NO_PICKUP_SLOTS');
      setIsMapView(false);
      setSelectedDeliveryOption({
        selectedType: 'No disponible',
        date: '',
        month: '',
        price: '',
        locationName: comunaName.toLowerCase(),
        storeName: selectedDeliveryOption.storeName,
        politicalId: selectedDeliveryOption.politicalId,
        storeId: selectedDeliveryOption.storeId,
        isError: true,
        isFreeShippingApplicable: false,
        parentStateName,
        deliveryOptionType: AVAILABILITY_PICKUPINSTORE,
      });
    }
  }
};

export {
  buildPickupItem,
  getPickupInStoreData,
  getPickupInStoreSlots,
  getSelectedPickupInStoreDetails,
  processPickupInStoreSlots,
};
